import React from 'react';
import { Outlet } from 'react-router-dom';
import { Wrench, Github, Twitter } from 'lucide-react';

export function Header() {
  return (
    <header className="bg-gray-900 border-b border-gray-800">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Wrench className="w-6 h-6 text-emerald-500" />
            <a href="/" className="text-xl font-bold text-white">DigiVault.club</a>
          </div>
          <nav>
            <ul className="flex items-center gap-6">
              <li>
                <a href="/password-generator" className="text-gray-300 hover:text-white transition-colors">
                  Password Generator
                </a>
              </li>
              <li>
                <a href="/word-counter" className="text-gray-300 hover:text-white transition-colors">
                  Word Counter
                </a>
              </li>
              <li>
                <a href="/fake-name-generator" className="text-gray-300 hover:text-white transition-colors">
                  Name Generator
                </a>
              </li>
              <li>
                <a href="/blog" className="text-gray-300 hover:text-white transition-colors">
                  Blog
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

export function Footer() {
  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">DigiVault Tools</h3>
            <ul className="space-y-2">
              <li>
                <a href="/password-generator" className="text-gray-400 hover:text-white transition-colors">
                  Password Generator
                </a>
              </li>
              <li>
                <a href="/word-counter" className="text-gray-400 hover:text-white transition-colors">
                  Word Counter
                </a>
              </li>
              <li>
                <a href="/fake-name-generator" className="text-gray-400 hover:text-white transition-colors">
                  Name Generator
                </a>
              </li>
              <li>
                <a href="/hash-calculator" className="text-gray-400 hover:text-white transition-colors">
                  Hash Calculator
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <a href="/blog" className="text-gray-400 hover:text-white transition-colors">
                  Security Blog
                </a>
              </li>
              <li>
                <a href="/guides" className="text-gray-400 hover:text-white transition-colors">
                  Security Guides
                </a>
              </li>
              <li>
                <a href="/faq" className="text-gray-400 hover:text-white transition-colors">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Connect</h3>
            <div className="flex items-center gap-4">
              <a
                href="https://github.com/digivault"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Github className="w-6 h-6" />
              </a>
              <a
                href="https://twitter.com/digivault"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Twitter className="w-6 h-6" />
              </a>
            </div>
            <p className="mt-4 text-sm text-gray-400">
              Stay updated with our latest tools and security tips.
            </p>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-800 text-center text-gray-400 text-sm">
          <p>© {new Date().getFullYear()} DigiVault.club - All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-gray-900 to-gray-800">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}